"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_RSA_SIZE = exports.ONE_HOUR_SECS = void 0;
const ONE_HOUR_SECS = 60 * 60;
exports.ONE_HOUR_SECS = ONE_HOUR_SECS;
const DEFAULT_RSA_SIZE = 2048;
exports.DEFAULT_RSA_SIZE = DEFAULT_RSA_SIZE;